import { render } from "./ExchangeSettings.vue?vue&type=template&id=ab7a3c76"
import script from "./ExchangeSettings.vue?vue&type=script&lang=js"
export * from "./ExchangeSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/viapanelqualisof/admin.exchange.qualisoft.biz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__